import type { ApprovalAttributes } from '@/types/approval';
import {
  SERP_NOT_LOADED_MESSAGE,
  type SerpDocumentRef,
} from '@/utils/approval/serpDocument';

/** SERP 판매가 조정 — 레거시 appr_edit_forms_serp_sales */
export const SERP_SELLING_PRICE_TYPE = 160;

export const isSerpSellingPriceType = (apvType: number): boolean =>
  apvType === SERP_SELLING_PRICE_TYPE;

export type SerpSellingPriceShop = {
  SHOP_CD?: unknown;
  SHOP_ABBR_NM?: unknown;
};

export type SerpSellingPriceItem = {
  SSN_CD?: unknown;
  PROD_CD?: unknown;
  COLOR_CD?: unknown;
  PROD_KO_NM?: unknown;
  DISC_PRC?: unknown;
  SALE_URC?: unknown;
  DISC_RAT?: unknown;
};

/** EAI 응답 원문 — 저장 attributes.data 에 손대지 않고 그대로 보관 */
export type SerpSellingPriceSource = {
  BRAND_NM?: unknown;
  APRV_TIT?: unknown;
  APLY_STA_DE?: unknown;
  APLY_END_DE?: unknown;
  ALL_SHOP_YN?: unknown;
  SHOP_LIST?: SerpSellingPriceShop[] | null;
  COLOR_INFO?: {
    COLOR_LIST?: SerpSellingPriceItem[] | null;
    COLOR_CNT?: unknown;
  } | null;
  PROD_INFO?: {
    PROD_LIST?: SerpSellingPriceItem[] | null;
    PROD_CNT?: unknown;
  } | null;
  [key: string]: unknown;
};

export type SerpSellingPriceDraftSource = {
  code: number;
  attributes: SerpDocumentRef;
  display: { source?: SerpSellingPriceSource | null };
};

export type SerpSellingPriceState = SerpDocumentRef & {
  source: SerpSellingPriceSource;
};

export const checkSerpSellingPriceBeforeSave = (
  state: SerpSellingPriceState | null | undefined,
): string | null => (state?.source ? null : SERP_NOT_LOADED_MESSAGE);

export const buildSerpSellingPriceAttributes = (
  state: SerpSellingPriceState | null | undefined,
  content: string,
): ApprovalAttributes | null =>
  state?.source
    ? {
        typeCode: state.typeCode,
        sequence: state.sequence,
        content,
        data: state.source,
      }
    : null;
